/* eslint-disable */
/* eslint-disable no-alert */
import React, { useEffect, useState } from 'react';

import ReactModal from 'react-modal';
import closeSvg from 'src/assets/close.svg';

import { useTranslation } from 'react-i18next';
import { CloseIcon, FormTitle, Header } from './styles';
import { CreateBeneficiaries } from '../create-beneficiaries';
import { BeneficiariesList } from '../beneficiaries-list';
import { AlertAdapter, RegularButton } from 'pg-ui-library';
import BenefitsService from 'src/services/benefits.service';
import { useActions } from 'src/hooks/useActions';
import { useQuery } from '@tanstack/react-query';
import PersonalInfoService from 'src/services/personal-info.service';

export const BeneficiariesModal: React.FC<{
  isOpen: boolean;
  setBeneficiariesIsOpen?: any;
  benefitId: string;
}> = ({ isOpen, setBeneficiariesIsOpen, benefitId }) => {
  const { getPersonalInfo } = useActions();
  const [createBeneficiary, setCreateBeneficiary] = useState(false);
  const { t } = useTranslation();

  const handleBeneficiariesModal = () => {
    setCreateBeneficiary(false);
    setBeneficiariesIsOpen(!isOpen);
  };

  useEffect(() => {
    getPersonalInfo();
  }, [createBeneficiary]);

  return (
    <ReactModal
      isOpen={isOpen}
      ariaHideApp={false}
      onRequestClose={handleBeneficiariesModal}
      style={{
        overlay: {
          margin: 'auto',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
        },
        content: {
          borderRadius: '30px',
          margin: 'auto',
          width: '1300px',
          height: 'max-content',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          padding: '58px',
        },
      }}
    >
      <Header>
        <FormTitle>{t('benefits.beneficiaries.title')}</FormTitle>
        <CloseIcon src={closeSvg} onClick={() => handleBeneficiariesModal()} />
      </Header>
      {createBeneficiary ? (
        <CreateBeneficiaries
          benefitId={benefitId as unknown as ''}
          setCreateBeneficiary={setCreateBeneficiary}
          handleBeneficiariesModal={handleBeneficiariesModal}
        />
      ) : (
        <BeneficiariesList
          handleBeneficiariesModal={handleBeneficiariesModal}
          createBeneficiary={createBeneficiary}
          onSubmit={async beneficiaries => {
            try {
              await BenefitsService.addBeneficiarie({
                benefitId: benefitId,
                contacts: beneficiaries,
              });
              AlertAdapter('Beneficiaries added successfully!', 'success');
              handleBeneficiariesModal();
            } catch {
              AlertAdapter('Error when creating beneficiarie!', 'error');
            }
          }}
          onRequestNewBeneficiarie={() => {
            setCreateBeneficiary(true);
          }}
        />
      )}
    </ReactModal>
  );
};
